export default __webpack_public_path__ + "static/univers-bold-accfdb30f9838a380de1278a55c29857.woff";